import { getCurrentEnvMode } from '@/utils/tools';
const env = getCurrentEnvMode();
// 接口域名与页面域名不同的接口配置
const allLink = {
  dev: {
    upSpace: '',
    yihao: '',
  },
  test: {
    upSpace: 'https://testm.10jqka.com.cn/ozone/webpage/up-space/index.html',
    yihao: 'https://testm.10jqka.com.cn/dehydrationReport/index.html',
  },
  release: {
    upSpace: 'https://ozone.10jqka.com.cn/webpage/up-space/index.html',
    yihao: 'https://vaserviece.10jqka.com.cn/dehydrationReport/index.html',
  },
};

export default allLink[env];
